import {
  GET_SYSTEM_PARAMETERS,
  GET_SYSTEM_PARAMETERS_FAILED,
  GET_SYSTEM_PARAMETERS_SUCCESS,
  SAVE_SYSTEM_PARAMETERS,
  SAVE_SYSTEM_PARAMETERS_FAILED,
  SAVE_SYSTEM_PARAMETERS_SUCCESS,
  SYSTEM_PARAMETERS_NOT_FOUND,
} from './constants';

const getSystemParameters = () => ({
  type: GET_SYSTEM_PARAMETERS,
});

const getSystemParametersSuccess = (data) => ({
  type: GET_SYSTEM_PARAMETERS_SUCCESS,
  payload: { data },
});

const getSystemParametersFailed = (error) => ({
  type: GET_SYSTEM_PARAMETERS_FAILED,
  payload: { error },
});

const systemParametersNotFound = () => ({
  type: SYSTEM_PARAMETERS_NOT_FOUND,
});

const saveSystemParameters = (payload) => ({
  type: SAVE_SYSTEM_PARAMETERS,
  payload,
});

const saveSystemParametersSuccess = (data) => ({
  type: SAVE_SYSTEM_PARAMETERS_SUCCESS,
  payload: { data },
});

const saveSystemParametersFailed = (error) => ({
  type: SAVE_SYSTEM_PARAMETERS_FAILED,
  payload: { error },
});

export {
  getSystemParameters,
  getSystemParametersSuccess,
  getSystemParametersFailed,
  systemParametersNotFound,
  saveSystemParameters,
  saveSystemParametersSuccess,
  saveSystemParametersFailed,
};
